(function () {
  if (window.MRProductCardCarouselReadyV4) return;
  window.MRProductCardCarouselReadyV4 = true;

  const registry = new WeakMap();

  const TRANSITION_MS = 320;
  const MIN_SWIPE_PX = 32;
  const VELOCITY_THRESHOLD = 0.35;
  const DESKTOP_QUERY = '(min-width: 700px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function lockPageGesture() {
    document.documentElement.classList.add('pcc-gesture-lock');
    document.body.classList.add('pcc-gesture-lock');
  }

  function unlockPageGesture() {
    document.documentElement.classList.remove('pcc-gesture-lock');
    document.body.classList.remove('pcc-gesture-lock');
  }

  function initCarousel(root) {
    root = root || document;

    root.querySelectorAll('[data-pcc]').forEach(function (carousel) {
      if (registry.has(carousel)) return;

      const track = carousel.querySelector('.pcc-track');
      const progress = carousel.querySelector('.pcc-progress__active');
      const realSlides = carousel.querySelectorAll('.pcc-slide:not(.pcc-clone)');
      const realCount = realSlides.length;
      const previousArrow = carousel.querySelector('[data-pcc-arrow="previous"]');
      const nextArrow = carousel.querySelector('[data-pcc-arrow="next"]');

      if (!track || realCount < 2) {
        registry.set(carousel, true);
        return;
      }

      let index = 1;
      let startX = 0;
      let startY = 0;
      let deltaX = 0;
      let startTime = 0;
      let isDragging = false;
      let isAnimating = false;
      let isHorizontalGesture = false;
      let suppressClick = false;
      let fallbackTimer = null;
      let desktopActivated = false;

      carousel.style.setProperty('--pcc-progress-width', 100 / realCount + '%');
      carousel.style.setProperty('--pcc-progress-x', '0%');

      function visualIndex() {
        if (index === 0) return realCount - 1;
        if (index === realCount + 1) return 0;
        return index - 1;
      }

      function updateProgress() {
        if (!progress) return;
        carousel.style.setProperty('--pcc-progress-x', visualIndex() * 100 + '%');
      }

      function applyTransform(animate) {
        if (animate) {
          track.style.transition = '';
          carousel.classList.remove('is-resetting');
        } else {
          carousel.classList.add('is-resetting');
          track.style.transition = 'none';
        }

        track.style.transform = 'translate3d(' + (-index * 100) + '%, 0, 0)';
        updateProgress();

        if (!animate) {
          void track.offsetHeight;

          requestAnimationFrame(function () {
            track.style.transition = '';
            carousel.classList.remove('is-resetting');
          });
        }
      }

      function silentJump(newIndex) {
        index = newIndex;
        applyTransform(false);
      }

      function finishAnimation() {
        if (!isAnimating) return;

        isAnimating = false;

        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }

        if (index === 0) {
          silentJump(realCount);
          return;
        }

        if (index === realCount + 1) {
          silentJump(1);
          return;
        }

        updateProgress();
      }

      function goTo(newIndex) {
        if (isAnimating) return;

        index = newIndex;
        isAnimating = true;
        applyTransform(true);

        fallbackTimer = setTimeout(finishAnimation, TRANSITION_MS + 80);
      }

      function next() {
        goTo(index + 1);
      }

      function previous() {
        goTo(index - 1);
      }

      function activateDesktopCarousel(direction) {
        if (!isDesktop()) return;

        carousel.classList.add('is-desktop-active');

        if (!desktopActivated) {
          desktopActivated = true;

          if (direction === 'next') {
            if (realCount > 2) {
              silentJump(3);
            } else {
              silentJump(2);
            }
          } else {
            silentJump(1);
          }

          return;
        }

        if (direction === 'next') {
          next();
        } else {
          previous();
        }
      }

      function resetDesktopCarousel() {
        if (!isDesktop()) return;

        desktopActivated = false;
        carousel.classList.remove('is-desktop-active');
        silentJump(1);
      }

      track.addEventListener('transitionend', function (event) {
        if (event.target !== track) return;
        if (event.propertyName && event.propertyName !== 'transform') return;

        finishAnimation();
      });

      if (previousArrow) {
        previousArrow.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          activateDesktopCarousel('previous');
        });
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          activateDesktopCarousel('next');
        });
      }

      carousel.addEventListener('mouseleave', function () {
        resetDesktopCarousel();
      });

      carousel.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        if (isAnimating) return;

        isDragging = true;
        isHorizontalGesture = false;
        deltaX = 0;
        startX = event.clientX;
        startY = event.clientY;
        startTime = Date.now();

        track.classList.add('is-dragging');

        try {
          carousel.setPointerCapture(event.pointerId);
        } catch (e) {}
      });

      carousel.addEventListener(
        'pointermove',
        function (event) {
          if (!isDragging || isAnimating) return;

          const moveX = event.clientX - startX;
          const moveY = event.clientY - startY;
          const absX = Math.abs(moveX);
          const absY = Math.abs(moveY);

          if (!isHorizontalGesture && absX > 6 && absX > absY * 1.15) {
            isHorizontalGesture = true;
            carousel.classList.add('is-swiping');
            lockPageGesture();
          }

          if (!isHorizontalGesture) return;

          event.preventDefault();

          deltaX = moveX;

          const dragPercent = (deltaX / carousel.clientWidth) * 100;
          track.style.transform = 'translate3d(' + (-index * 100 + dragPercent) + '%, 0, 0)';
        },
        { passive: false }
      );

      function endGesture() {
        if (!isDragging) return;

        isDragging = false;
        track.classList.remove('is-dragging');

        if (!isHorizontalGesture) {
          carousel.classList.remove('is-swiping');
          unlockPageGesture();
          applyTransform(true);
          return;
        }

        const elapsed = Math.max(Date.now() - startTime, 1);
        const velocity = Math.abs(deltaX) / elapsed;

        suppressClick = true;

        if (deltaX < -MIN_SWIPE_PX || (deltaX < -10 && velocity > VELOCITY_THRESHOLD)) {
          next();
        } else if (deltaX > MIN_SWIPE_PX || (deltaX > 10 && velocity > VELOCITY_THRESHOLD)) {
          previous();
        } else {
          goTo(index);
        }

        setTimeout(function () {
          suppressClick = false;
          carousel.classList.remove('is-swiping');
          unlockPageGesture();
        }, TRANSITION_MS + 120);
      }

      carousel.addEventListener('pointerup', endGesture);
      carousel.addEventListener('pointercancel', endGesture);
      carousel.addEventListener('lostpointercapture', endGesture);

      carousel.addEventListener(
        'click',
        function (event) {
          if (suppressClick) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );

      registry.set(carousel, true);
      silentJump(1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCarousel(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCarousel(event.target);
  });

  let observerFrame = null;

  const observer = new MutationObserver(function () {
    if (observerFrame) return;

    observerFrame = requestAnimationFrame(function () {
      initCarousel(document);
      observerFrame = null;
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();